
















import Vue from 'vue'
import EditOrAddMenu from './EditOrAddMenu.vue'
import ApiList from './ApiList.vue'
export default Vue.extend({
  data() {
    return {
      tabIndex: '0'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    chooseMenuKind: {
      type: String,
      default: ''
    },
    menuTypeList: {
      type: Array,
      default: ()=>[]
    },
    audienceList: {
      type: Array,
      default: ()=>[]
    }
  },
  components: {
    EditOrAddMenu,
    ApiList
  },
  watch: {
    tabIndex(val) {
      console.log(val)
    },
  },
  methods: {
    changeTab(index: string) {
      console.log('index', index)
      this.tabIndex = index
    },
    editMenuBack(flag: boolean) {
      this.$emit('close', flag)
    }
  }
})
